import type EstimateValues from "../../types/params"
import { isMetal } from "../oneClickIs"

const FIELD_TYPE = {
  BOOLEAN: "boolean",
  RADIO: "radio",
  NUMBER: "number",
  DATE: "date",
} as const

const definition = {
  serviceD: {
    type: FIELD_TYPE.BOOLEAN,
    displayName: "基板設計",
  },
  serviceM: {
    type: FIELD_TYPE.BOOLEAN,
    displayName: "基板製造",
  },
  serviceG: {
    type: FIELD_TYPE.BOOLEAN,
    displayName: "部品実装",
  },
  partsProcurementCourse: {
    type: FIELD_TYPE.BOOLEAN,
    displayName: "部品調達",
  },
  kibanType: {
    type: FIELD_TYPE.RADIO,
    displayName: "基板の種類",
  },
  metalBoard: {
    type: FIELD_TYPE.RADIO,
    displayName: "メタル材質",
  },
  layer: {
    type: FIELD_TYPE.RADIO,
    displayName: "構成層数",
  },
  patternSide: {
    type: FIELD_TYPE.RADIO,
    displayName: "パターン面",
  },
  sizeX: {
    type: FIELD_TYPE.NUMBER,
    displayName: "外形寸法",
  },
  sizeY: {
    type: FIELD_TYPE.NUMBER,
    displayName: "外形寸法",
  },
  fpcRectangularShape: {
    type: FIELD_TYPE.RADIO,
    displayName: "矩形形状",
  },
  pinCnt: {
    type: FIELD_TYPE.NUMBER,
    displayName: "ピン数",
  },
  planCadDataKbn: {
    type: FIELD_TYPE.RADIO,
    displayName: "CAD選択",
  },
  fileKbn: {
    type: FIELD_TYPE.RADIO,
    displayName: "回路図の支給形態",
  },
  externalsSilk: {
    type: FIELD_TYPE.RADIO,
    displayName: "外形が特殊形状・カードエッジコネクタ",
  },
  designInstruction: {
    type: FIELD_TYPE.RADIO,
    displayName: "固有の仕様書・設計指示書",
  },
  cnt: {
    type: FIELD_TYPE.NUMBER,
    displayName: "製造枚数",
  },
  sheetCnt: {
    type: FIELD_TYPE.NUMBER,
    displayName: "実装枚数",
  },
  solderType: {
    type: FIELD_TYPE.RADIO,
    displayName: "半田種類",
  },
  pieceCnt: {
    type: FIELD_TYPE.NUMBER,
    displayName: "表面実装部品（SMD一般）",
  },
  bgacsp: {
    type: FIELD_TYPE.NUMBER,
    displayName: "本体下に端子が隠れている部品",
    // displayNameFor1Click: "本体下に端子が隠れている部品（BGA/CSP/LGA/QFN/Exposed-Padがある部品）",
  },
  sideOfSmd: {
    type: FIELD_TYPE.RADIO,
    displayName: "実装面",
  },
  dipPartCnt: {
    type: FIELD_TYPE.NUMBER,
    displayName: "挿入部品（DIP）",
  },
  sideOfDip: {
    type: FIELD_TYPE.RADIO,
    displayName: "実装面",
  },
  metalmask: {
    type: FIELD_TYPE.RADIO,
    displayName: "実装方法",
  },
  provisionOfMountData: {
    type: FIELD_TYPE.RADIO,
    displayName: "マウントデータの支給",
  },
  metalMaskDtl: {
    type: FIELD_TYPE.RADIO,
    displayName: "メタルマスクの製造・支給選択",
  },
  freeMaterialsFlg: {
    type: FIELD_TYPE.RADIO,
    displayName: "P板.com無料提供部品",
  },
  userProvPartFlg: {
    type: FIELD_TYPE.RADIO,
    displayName: "お客様支給部品",
  },
  materialsArrivalDate: {
    type: FIELD_TYPE.DATE,
    displayName: "部材到着予定日",
  },
  board: {
    type: FIELD_TYPE.RADIO,
    displayName: "材質",
  },
  boardThickness: {
    type: FIELD_TYPE.RADIO,
    displayName: "板厚",
  },
  fpcBoardThickness: {
    type: FIELD_TYPE.RADIO,
    displayName: "ベース材厚",
  },
  almThickness: {
    type: FIELD_TYPE.RADIO,
    displayName: "ベース／コアの厚み",
  },
  beatenThickness: {
    type: FIELD_TYPE.RADIO,
    displayName: "銅箔厚み",
  },
  buildUpMethod: {
    type: FIELD_TYPE.RADIO,
    displayName: "ビルドアップ工法",
  },
  minPattern: {
    type: FIELD_TYPE.RADIO,
    displayName: "最小パターン幅／間隔",
  },
  minLand: {
    type: FIELD_TYPE.RADIO,
    displayName: "最小ビア径／ランド径",
  },
  laserVia: {
    type: FIELD_TYPE.RADIO,
    displayName: "レーザービア径／ランド径",
  },
  controlWiring: {
    type: FIELD_TYPE.RADIO,
    displayName: "配置／配線（配線幅・配線長・シールド）ルール",
  },
  circuit: {
    type: FIELD_TYPE.RADIO,
    displayName: "高電流（10A以上）高電圧（50V以上）多電源（4種以上）",
  },
  planBgacsp: {
    type: FIELD_TYPE.RADIO,
    displayName: "BGA／CSP",
  },
  otherSilk: {
    type: FIELD_TYPE.RADIO,
    displayName: "シルク追加10個以上（部品番号・ピン番除く）",
  },
  impedance: {
    type: FIELD_TYPE.RADIO,
    displayName: "特性インピーダンスコントロール",
  },
  resistPrint: {
    type: FIELD_TYPE.RADIO,
    displayName: "塗布する面",
  },
  resistColor: {
    type: FIELD_TYPE.RADIO,
    displayName: "レジスト色",
  },
  coverLaySide: {
    type: FIELD_TYPE.RADIO,
    displayName: "貼る面",
  },
  coverLay: {
    type: FIELD_TYPE.RADIO,
    displayName: "カバーレイ",
  },
  coverLayColor: {
    type: FIELD_TYPE.RADIO,
    displayName: "カバーレイ色",
  },
  silk: {
    type: FIELD_TYPE.RADIO,
    displayName: "印刷する面",
  },
  silkColor: {
    type: FIELD_TYPE.RADIO,
    displayName: "シルク印刷色",
  },
  silkPrintMethod: {
    type: FIELD_TYPE.RADIO,
    displayName: "シルク印刷工法",
  },
  surfaceFinishing: {
    type: FIELD_TYPE.RADIO,
    displayName: "表面処理",
  },
  hardGoldOnPCIEdgeTerminal: {
    type: FIELD_TYPE.RADIO,
    displayName: "端子部のみ電解金めっき",
  },
  chamferingProcess: {
    type: FIELD_TYPE.RADIO,
    displayName: "端子部の面取り加工",
  },
  rfContactPortionCnt: {
    type: FIELD_TYPE.RADIO,
    displayName: "端子部厚み指定",
  },
  rfContactPortion1: {
    type: FIELD_TYPE.RADIO,
    displayName: "仕上り厚み指定（1箇所目）",
  },
  rfContactPortionBonding1: {
    type: FIELD_TYPE.RADIO,
    displayName: "接着面（1箇所目）",
  },
  rfContactPortion2: {
    type: FIELD_TYPE.RADIO,
    displayName: "仕上り厚み指定（2箇所目）",
  },
  rfContactPortionBonding2: {
    type: FIELD_TYPE.RADIO,
    displayName: "接着面（2箇所目）",
  },
  reinForcementCnt: {
    type: FIELD_TYPE.RADIO,
    displayName: "補強板厚み指定",
  },
  reinForcement1: {
    type: FIELD_TYPE.RADIO,
    displayName: "厚み指定（1箇所目）",
  },
  reinForcementBonding1: {
    type: FIELD_TYPE.RADIO,
    displayName: "接着面（1箇所目）",
  },
  reinForcement2: {
    type: FIELD_TYPE.RADIO,
    displayName: "厚み指定（2箇所目）",
  },
  reinForcementBonding2: {
    type: FIELD_TYPE.RADIO,
    displayName: "接着面（2箇所目）",
  },
  panelizedItemCnt: {
    type: FIELD_TYPE.NUMBER,
    displayName: "面付け数",
  },
  panelizedItemKindCnt: {
    type: FIELD_TYPE.NUMBER,
    displayName: "面付け数",
  },
  fpcSurfacePutData: {
    type: FIELD_TYPE.RADIO,
    displayName: "FPC面付けされたデータ",
  },
  vcutCnt: {
    type: FIELD_TYPE.NUMBER,
    displayName: "Vカット",
  },
  jumpVcutCnt: {
    type: FIELD_TYPE.NUMBER,
    displayName: "ジャンプVカット",
  },
  routerCut: {
    type: FIELD_TYPE.RADIO,
    displayName: "ルーター切り出し面付け",
  },
  routerCutKind: {
    type: FIELD_TYPE.NUMBER,
    displayName: "ルーター切り出し面付け",
  },
  roulette: {
    type: FIELD_TYPE.RADIO,
    displayName: "ミシン目面付け",
  },
  rouletteKind: {
    type: FIELD_TYPE.NUMBER,
    displayName: "ミシン目面付け",
  },
  dataService: {
    type: FIELD_TYPE.RADIO,
    displayName: "データ面付け編集サービス",
  },
  discardBoardMark: {
    type: FIELD_TYPE.BOOLEAN,
    displayName: "捨て基板",
  },
  recognizeMark: {
    type: FIELD_TYPE.BOOLEAN,
    displayName: "実装認識マーク",
  },
  editVariantSlit: {
    type: FIELD_TYPE.BOOLEAN,
    displayName: "異形外形スリット枠",
  },
  semiTh: {
    type: FIELD_TYPE.RADIO,
    displayName: "端面スルーホール",
  },
  longHole: {
    type: FIELD_TYPE.RADIO,
    displayName: ({ kibanType }: Pick<EstimateValues, "kibanType">) => {
      return isMetal({ kibanType }) ? "長穴/くりぬき加工/φ6.35mm以上の丸穴" : "長穴"
    },
  },
  padOnVia: {
    type: FIELD_TYPE.RADIO,
    displayName: "パッド・オン・ビア",
  },
  padLess03: {
    type: FIELD_TYPE.RADIO,
    displayName: "0.3mm未満のパッド",
  },
  emcShield: {
    type: FIELD_TYPE.RADIO,
    displayName: "電磁波シールド",
  },
  ulMark: {
    type: FIELD_TYPE.RADIO,
    displayName: "ULマーク",
  },
  aoiInspection: {
    type: FIELD_TYPE.RADIO,
    displayName: "AOI検査（外観光学検査）",
  },
  manufactureInspectionCertificate: {
    type: FIELD_TYPE.RADIO,
    displayName: "製造検査成績書",
  },
  mountInspectionCertificate: {
    type: FIELD_TYPE.RADIO,
    displayName: "実装検査成績書",
  },
  dxfData: {
    type: FIELD_TYPE.RADIO,
    displayName: "データ形式",
  },
  manuOptPlanCad: {
    type: FIELD_TYPE.RADIO,
    displayName: "設計CAD",
  },
  estManuFactoryId: {
    type: FIELD_TYPE.RADIO,
    displayName: "製造工場",
  },
  rigidFlexPcb: {
    type: FIELD_TYPE.RADIO,
    displayName: "リジッドフレキ基板",
  },
  wireBonding: {
    type: FIELD_TYPE.RADIO,
    displayName: "ワイヤーボンディング",
  },
  awDataSupplied: {
    type: FIELD_TYPE.RADIO,
    displayName: "AWデータ支給設計（CAD／LIB必須）",
  },
  panelized: {
    type: FIELD_TYPE.RADIO,
    displayName: "面付け",
  },
  ddrEmc: {
    type: FIELD_TYPE.RADIO,
    displayName: "DDR I／F・EMC設計（伝送線路シミュレーション等）",
  },
  designDaysShortening: {
    type: FIELD_TYPE.RADIO,
    displayName: "納期短縮対応",
  },
  dxfDataOutput: {
    type: FIELD_TYPE.RADIO,
    displayName: "DXFデータ出力",
  },
  deliveryZeroFlg: {
    type: FIELD_TYPE.BOOLEAN,
    displayName: "デリバリーゼロ（出荷当日納品）",
  },
  mountQuickFlg: {
    type: FIELD_TYPE.BOOLEAN,
    displayName: "実装短納期あり",
  },
} as const

export default definition
